var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.setHero,
          expression: "setHero",
        },
      ],
      staticClass: "min-h-screen",
    },
    [
      _c("noscript", [
        _c("iframe", {
          staticStyle: { display: "none", visibility: "hidden" },
          attrs: {
            src: "https://www.googletagmanager.com/ns.html?id=GTM-MFH878M",
            height: "0",
            width: "0",
          },
        }),
      ]),
      _vm._v(" "),
      _c("noscript", [
        _c("img", {
          staticStyle: { display: "none" },
          attrs: {
            height: "1",
            width: "1",
            src: "https://www.facebook.com/tr?id=220594841032999&ev=PageView&noscript=1",
          },
        }),
      ]),
      _vm._v(" "),
      false
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                [
                  _c("v-card-subtitle", [
                    _vm._v(
                      "\n                Network error detected. No offline access.\n            "
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.version?.outage
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                [
                  _c("v-card-subtitle", [
                    _vm._v(
                      "\n                Temporary service outage. This app might not work as\n                expected. Thanks!\n            "
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.impersonating?.impersonatingUser &&
      !_vm.showBanner?.some((e) => e.show)
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-blue white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                { staticClass: "flex justify-center" },
                [
                  _c("v-card-subtitle", { staticClass: "align-self-center" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          `Impersonating ${this.$page.props.auth.user.name}`
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "my-3",
                      attrs: { color: "white", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.stopImpersonating()
                        },
                      },
                    },
                    [_vm._v("\n                Return\n            ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-app-bar",
        {
          ref: "appBar",
          class: { "px-6": _vm.$vuetify.breakpoint.smAndUp },
          attrs: {
            app: "",
            color: "white",
            height: "64",
            "elevate-on-scroll": "",
            "hide-on-scroll": _vm.hideNavOnScroll,
            "scroll-threshold": "124",
          },
        },
        [
          _c(
            "Link",
            {
              attrs: { href: _vm.$page.props.auth.user ? "/" : "/get-started" },
            },
            [
              _c("jet-application-logo", {
                staticClass: "block w-auto",
                class: _vm.$vuetify.breakpoint.xs ? "h-6" : "h-9",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-end align-center" },
            [
              !!_vm.location
                ? _c("div", { staticClass: "mr-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "v-btn--text full-round",
                        attrs: { href: "tel:" + _vm.location.phone },
                      },
                      [
                        _vm.$vuetify.breakpoint.smAndUp
                          ? _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.location.phone) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$vuetify.breakpoint.xs
                          ? _c("v-icon", { attrs: { color: "dark" } }, [
                              _vm._v("phone"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.$page.props.auth.user
                ? _c(
                    "SoliBtn",
                    {
                      staticStyle: { color: "white !important" },
                      attrs: { color: "gradient-orange", href: "/login" },
                    },
                    [_vm._v("Login")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("SoliProfileDropdown", {
                on: {
                  success: function ($event) {
                    _vm.showMessage = true
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-img",
        {
          class: { "bg-gradient-b": _vm.bgGradient },
          attrs: { id: "bg-stars", src: _vm.img },
        },
        [
          _c(
            "div",
            {
              staticClass: "absolute w-full",
              class: { "px-6": _vm.$vuetify.breakpoint.smAndUp },
              staticStyle: { top: "64px", "z-index": "100" },
              attrs: { id: "toolbar" },
            },
            [
              _vm.breadcrumbs
                ? _c(
                    "v-row",
                    { staticClass: "px-4", attrs: { "no-gutters": "" } },
                    [
                      _c("v-breadcrumbs", {
                        staticClass: "px-0",
                        attrs: { items: _vm.getBreadcrumbs, dark: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function ({ item }) {
                                return [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "bread-link",
                                        class: {
                                          "v-breadcrumbs__item--disabled":
                                            item.disabled,
                                        },
                                        attrs: { href: item.href },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.text)
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          684605460
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex align-center justify-end" },
                        [_vm._t("toggleFilter")],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            {
              class: { testimonial: _vm.review },
              attrs: { "fill-height": _vm.fillHeight, fluid: _vm.fluid },
            },
            [
              _c(
                "v-main",
                [
                  _c(
                    "v-row",
                    {
                      staticClass:
                        "white--text animate__animated animate__fadeIn py-3",
                      class: { "mt-6": _vm.breadcrumbs },
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _vm.title
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "white--text justify-center pa-6 w-full flex-col text-center font-weight-bold",
                              class: {
                                "text-h6": _vm.$vuetify.breakpoint.xs,
                                "text-h5": _vm.$vuetify.breakpoint.sm,
                                "text-h4": _vm.$vuetify.breakpoint.mdAndUp,
                              },
                            },
                            [
                              _c("div", {
                                staticStyle: {
                                  "white-space": "pre",
                                  "line-height": "1.6rem",
                                },
                                domProps: { innerHTML: _vm._s(_vm.title) },
                              }),
                              _vm._v(" "),
                              _vm.subtitle
                                ? _c("div", {
                                    class: [
                                      _vm.$vuetify.breakpoint.smAndDown
                                        ? "text-body-1"
                                        : "text-h6",
                                      "pt-0.5",
                                    ],
                                    domProps: {
                                      innerHTML: _vm._s(_vm.subtitle),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("titleAction"),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("default"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.needHelp
                    ? _c(
                        "div",
                        { staticClass: "py-3 justify-center flex" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-capitalize soli-round",
                              attrs: {
                                small: "",
                                text: "",
                                color: "white",
                                large: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showContact()
                                },
                              },
                            },
                            [_vm._v("Need help? Contact Us")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.review
            ? _c(
                "v-container",
                { staticClass: "flex justify-center", attrs: { id: "review" } },
                [
                  _c("div", {
                    staticClass: "background-circle",
                    class: {
                      "mobile-circle": _vm.$vuetify.breakpoint.smAndDown,
                    },
                  }),
                  _vm._v(" "),
                  _c("SoliReview", { attrs: { review: _vm.review } }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLocationsForm
        ? _c("SoliResponsiveDialog", {
            ref: "locationContact",
            attrs: { title: "Contact Us!" },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showLocationsForm = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliLocations", {
                        attrs: {
                          parentLocations: _vm.location
                            ? [_vm.location]
                            : _vm.locations,
                          value: _vm.location,
                          iterator: "",
                          showAddress: "",
                          hideDetails: "",
                          expandable: "",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1500858725
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContactForm
        ? _c("ShortContactForm", {
            ref: "shortContactForm",
            attrs: {
              programInquiry: _vm.programInquiry,
              guest: _vm.guest || _vm.$page.props.auth.user,
              child: _vm.child,
              errors: _vm.errors,
            },
            on: {
              submit: function ($event) {
                _vm.closeModal(() => (_vm.showContactForm = false))
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showContactForm = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.errors.soliError
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: _vm.errors.soliError,
              button1: "Okay",
              link1: _vm.errors.soliError.includes("exists") ? "/login" : null,
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => {
                  const pageErrors = _vm.$page.props.errors
                  const { ["soliError"]: unused, ...errors } = pageErrors
                  _vm.$page.props.errors = errors
                })
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.errors.contactSupport
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: _vm.errors.contactSupport,
              button1: "Contact Us!",
            },
            on: {
              option1: function ($event) {
                ;[
                  (_vm.showLocationsForm = true),
                  _vm.closeModal(() => {
                    const pageErrors = _vm.$page.props.errors
                    const { ["contactSupport"]: unused, ...errors } = pageErrors
                    _vm.$page.props.errors = errors
                  }),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.errors.expired
        ? _c("SoliChoice", {
            attrs: {
              title: "Sorry!",
              subtitle: _vm.errors.expired,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.$page.props.errors.expired = null))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("SiteFooter", {
        attrs: {
          locations: _vm.locations,
          hideFab: _vm.hideFab,
          fixedFab: _vm.fixedFab,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }